export default __webpack_public_path__ + "static/media/blog_4.665841d4.png";